import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { BridgeService, Load, SessionState, WindowService } from '@myvf/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'myvf-container',
  template: `
		<div class="myvf-container-wrapper" [class.pages-in-bottom]="isBottom" [class.ios]="isIos">
			<div class="myvf-container">
				<router-outlet></router-outlet>
			</div>
			<myvf-loader></myvf-loader>
			<myvf-notification></myvf-notification>
			<myvf-sticky></myvf-sticky>
			<myvf-custom-error></myvf-custom-error>
		</div>
  `,
  styleUrls: ['./container.component.scss'],
})
export class ContainerComponent implements OnInit {
  public isBottom: boolean;
  public isIos: boolean;

  constructor(
    private store: Store,
    private window: WindowService,
    private bridge: BridgeService,
    private router: Router,
    private location: Location
  ) {
  }

  ngOnInit(): void {
    const {isOverlay} = this.store.selectSnapshot(SessionState);
    this.isBottom = typeof isOverlay !== 'undefined' ? !isOverlay : false;
    this.isIos = this.window.isiOS();


    this.bridge.events.subscribe((event) => {
      if (event instanceof Load) {
        const {url} = event;
        if (url === 'back') {
          this.location.back();
        } else if (url.toLowerCase().indexOf('myvfitbiz') >= 0) {
          this.bridge.manageUrlScheme(url);
        } else {
          const queryParams = this.window.decodeQueryParams(url);
          this.router.navigate([url.split('?')[0]], {queryParams});
        }
      }
    });
  }
}
